import { platformStore } from "./platform/index.js";

export const state = { ...platformStore.state };

export const mutations = { ...platformStore.mutations };

export const getters = { ...platformStore.getters };

export const actions = { ...platformStore.actions };
